import Vue from 'vue'
import Plyr from 'plyr'
import screenfull from 'screenfull'
import entries from 'object.entries'
import { isSP, isPC, isIos, isIos10 } from '@/utvStore/components/VideoPlayer/utils/device'
import sendGaEvent from '@/utvStore/components/VideoPlayer/utils/sendGaEvent'

if (isIos) {
  require('rangetouch')
}

if (typeof Object.entries === 'undefined') {
  Object.entries = entries
}

class LiveVideoControls {
  constructor(el, binding, vnode) {
    //this.vnode = vnode
    this.video = el
    this.plyr = null
    this.plyrElem = null
    this.header = null
    this.main = null
    this.scrollTop = 0
  }

  initialize() {
    const controls = ['mute', 'volume', 'fullscreen']
    const options = { controls, clickToPlay: false }
    this.plyr = new Plyr(this.video, options)
    this.plyr.speed = 1
    this.play()
    this.plyr.on('enterfullscreen', this.onEnterFullscreen.bind(this))
    this.plyr.on('exitfullscreen', this.onExitFullscreen.bind(this))
    this.plyrElem = document.querySelector('.plyr--fullscreen-enabled')
    this.main = document.querySelector('main')
    this.header = document.querySelector('.header')
  }

  // 自動再生ポリシー対応
  // https://qiita.com/ktknest/items/e81b3a4caac540098fc8
  play() {
    this.plyr.muted = false
    this.plyr.volume = 1
    const playedPromise = this.plyr.play()
    if (playedPromise !== undefined) {
      playedPromise.catch(error => {
        this.vnode.context.$emit('failedAutoPlay')
        this.plyr.muted = true
        this.plyr.play()
      })
    }
  }

  onEnterFullscreen() {
    // if (!screenfull.enabled && this.video.webkitEnterFullscreen) {
    //   this.video.webkitEnterFullscreen()
    //   this.plyr.fullscreen.exit()
    // }
    this.plyrElem.classList.add('plyr--fullscreen--enter')
    this.header.classList.add('header--fullscreen')
    if (isIos) {
      this.setMainElemStyle('80vh', '80vh', 'hidden')
    }
    this.gaEvent({ event: 'click', category: 'fullscreen-mode', label: 'on' })
  }

  onExitFullscreen() {
    this.plyrElem.classList.remove('plyr--fullscreen--enter')
    this.header.classList.remove('header--fullscreen')
    if (isIos) {
      this.setMainElemStyle('auto', '100vh', 'static')
      window.scrollTo(0, this.scrollTop)
    }
    this.gaEvent({ event: 'click', category: 'fullscreen-mode', label: 'off' })
  }

  gaEvent(data) {
    sendGaEvent(
      Object.assign(data, {
        trackingCode: 'UA-100415034-1'
      })
    )
    sendGaEvent(
      Object.assign(data, {
        trackingCode: 'UA-100415034-5'
      })
    )
  }

  setMainElemStyle(height, minHeight, overflow) {
    this.main.style.height = height
    this.main.style.overflow = overflow
    this.main.style.minHeight = minHeight
  }

  setScrollTop() {
    this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
  }
}

class VodVideoControls {
  constructor(el, binding, vnode) {
    this.video = null
    this.isTheater = false
    this.posterElem = null
    this.plyr = null
    this.plyrElem = null
    this.header = null
    this.speedList = []
    this.speedIndex = 0
    this.plyrControls = null
    this.speedBtn = null
    this.seekBtn = null
    this.speedTextElem = null
    this.speedText = ''
    this.theaterBtn = null
    this.cmLinkBtn = null
    this.cmSkipBtn = null
    this.movieShowInfo = null
    this.main = null
    this.scrollTop = 0
    this.flagShowCmTarget = false
    this.flagShowCmSkip = false
    this.isStreamingAd = false
    this.vnode = vnode

    this.video = el
    this.isTheater = binding.arg === 'isTheater'
    // this.isVisible = binding.value
    const controlsElem = `
                           <div id="js-controls" class="plyr__controls plyr__controls--vod">
                           <div class="plyr__cmInfo">
                           <div class="plyr__cmLabel">
                           CM
                           </div>
                           <div class="plyr__cmTarget">
                           <a href="" target="_blank">詳しく見る</a>
                           </div>
                           <div class="plyr__cmSkip">
                           スキップ
                           </div>
                           </div>
                           <button type="button" class="plyr__control" aria-label="speed" data-plyr="speed">
                           <span>1.0X</span>
                           </button>
                           <button type="button" class="plyr__control" aria-label="Play, {title}" data-plyr="play">
                           <span class="label--pressed plyr__tooltip" role="tooltip">Pause</span>
                           <span class="label--not-pressed plyr__tooltip" role="tooltip">Play</span>
                           </button>
                           <div class="plyr__progress">
                           <input data-plyr="seek" type="range" min="0" max="100" step="0.01" value="0" id="plyr-seek-{id}">
                           <progress class="plyr__progress__buffer" min="0" max="100" value="0">% buffered</progress>
                           <span role="tooltip" class="plyr__tooltip">00:00</span>
                           </div>
                           <div class="plyr__time plyr__time--current" aria-label="Current time">00:00</div>
                           <div class="plyr__time plyr__time--duration" aria-label="Duration">00:00</div>
                           <div class="plyr__volume">
                           <button type="button" class="plyr__control" aria-label="Mute" data-plyr="mute">
                           <span class="label--pressed plyr__tooltip" role="tooltip">Unmute</span>
                           <span class="label--not-pressed plyr__tooltip" role="tooltip">Mute</span>
                           </button>
                           <input data-plyr="volume" type="range" min="0" max="1" step="0.05" value="1" autocomplete="off" aria-label="Volume">
                           </div>
                           <button type="button" class="plyr__control" data-plyr="theater" aria-pressed="false">
                           </button>
                           <button type="button" class="plyr__control" data-plyr="fullscreen">
                           <span class="label--pressed plyr__tooltip" role="tooltip">Exit fullscreen</span>
                           <span class="label--not-pressed plyr__tooltip" role="tooltip">Enter fullscreen</span>
                           </button>
                           <div class="modeText">
                           </div>
                           </div>
                           `

    const controls = controlsElem
    this.speedList = [1, 1.5, 2]
    const options = {
      controls,
      invertTime: true,
      toggleInvert: false
    }
    this.plyr = new Plyr(this.video, options)
    this.speedIndex = 0
    this.speedText = '1.0X'
    this.speedBtn = document.querySelector('.plyr__control[data-plyr="speed"]')
    this.speedTextElem = document.querySelector('.plyr__control[data-plyr="speed"] > span')
    this.theaterBtn = document.querySelector('.plyr__control[data-plyr="theater"]')
    this.seekBtn = document.querySelector('input[data-plyr="seek"]')
    this.plyrControls = document.getElementById('js-controls')
    this.cmLinkBtn = document.querySelector('.plyr__cmTarget > a')
    this.cmSkipBtn = document.querySelector('.plyr__cmSkip')
    this.movieShowInfo = document.querySelector('.movieShowInfo')
    this.main = document.querySelector('main')

    this.plyr.speed = 1
    if (!this.isTheater) {
      this.theaterBtn.setAttribute('style', 'display:none')
    } else {
      this.theaterBtn.addEventListener('click', this.toggleTheater.bind(this))
    }

    this.speedBtn.addEventListener('click', this.changeSpeed.bind(this))
    this.vnode.context.poster && this.setPoster()
    // this.plyr.on('ready', this.onReady.bind(this))
    this.toggleControls(this.vnode.context.controls)
    this.isStreamingAd = this.vnode.context.isStreamingAd
    this.plyr.on('play', this.onPlay.bind(this))
    this.plyr.on('enterfullscreen', this.onEnterFullscreen.bind(this))
    this.plyr.on('exitfullscreen', this.onExitFullscreen.bind(this))
    this.plyr.on('ended', this.onEnded.bind(this))
    this.plyr.on('pause', this.onPause.bind(this))
    this.seekBtn.addEventListener('input', this.onSeeking.bind(this), false)
    this.seekBtn.addEventListener('change', this.onSeeked.bind(this), false)
    this.cmSkipBtn.addEventListener(
      'click',
      () => {
        this.toggleControls(false)
        this.vnode.context.$emit('clickCmSkipBtn')
        this.vnode.context.$emit('ended')
      },
      false
    )
    this.cmLinkBtn.addEventListener('click', () => {
      this.vnode.context.$emit('clickCmTargetBtn')
    })
    this.plyrElem = document.querySelector('.plyr--fullscreen-enabled')
    this.header = document.querySelector('.header')
    this.flagShowCmTarget = false
    this.flagShowCmSkip = false
    if (isIos10) {
      this.plyrControls.classList.add('plyr__controls--ios10')
    }
  }

  changeSpeed() {
    this.gaEvent({ event: 'click', category: 'playspeed-button', label: this.speedText })
    // ga('send', 'event', 'playspeed-button', 'click', this.speedText, 1, { 'nonInteraction': 1 });
    this.speedIndex += 1
    if (typeof this.speedList[this.speedIndex] === 'undefined') {
      this.speedIndex = 0
    }

    const speed = this.speedList[this.speedIndex]
    this.plyr.speed = speed
    this.speedText = `${speed.toString().length === 1 ? speed.toFixed(1) : speed}X`
    this.speedTextElem.innerHTML = this.speedText
  }

  toggleTheater() {
    if (!this.movieShowInfo) return
    const movieShowInfoclassName = 'movieShowInfo--theaterMode'
    const plyrClassName = 'plyr--theaterMode'
    const mode = this.movieShowInfo.classList.contains(movieShowInfoclassName) ? 'off' : 'on'
    this.plyrElem.classList.toggle(plyrClassName)
    this.movieShowInfo.classList.toggle(movieShowInfoclassName)
    this.gaEvent({ event: 'click', category: 'theater-mode', label: mode })
  }

  // onReady() {
  //   this.toggleControls(this.isVisible)
  //   this.vnode.context.$emit('ready')
  // }

  onPlay() {
    const context = this.vnode.context
    if (context.poster) {
      this.posterElem.classList.add('videoControls__poster--disabled')
      // this.video.poster = ''
      this.video.style.display = 'block'
    }

    if (context.isStreamingAd) {
      if (context.nextAd.link_url) {
        this.cmLinkBtn.setAttribute('href', context.nextAd.link_url)
        this.cmLinkBtn.classList.add('plyr__cmTarget--show')
        if (!this.flagShowCmTarget) {
          this.vnode.context.$emit('showCmTarget')
          this.flagShowCmTarget = true
        }
      }

      if (context.nextAd.ads_type === 'skip') {
        const timer = setInterval(() => {
          if (this.plyr.currentTime >= 7) {
            clearInterval(timer)
            this.cmSkipBtn.classList.add('plyr__cmSkip--show')
            if (!this.flagShowCmSkip) {
              this.vnode.context.$emit('showCmSkip')
              this.flagShowCmSkip = true
            }
          }
        }, 1000)
      }
      this.plyrControls.classList.add('plyr__controls--cm')
    } else {
      this.plyrControls.classList.remove('plyr__controls--cm')
      this.cmSkipBtn.classList.remove('plyr__cmSkip--show')
      this.cmLinkBtn.classList.remove('plyr__cmTarget--show')
      this.cmSkipBtn.classList.remove('plyr__cmSkip--show')
      this.plyr.speed = this.speedList[this.speedIndex]
    }

    const timer = setInterval(() => {
      if (this.plyr.playing) {
        this.toggleControls(true)
        clearInterval(timer)
      }
    }, 300)
    this.vnode.context.$emit('played')
  }

  onEnded() {
    if (!screenfull.enabled && this.video.webkitExitFullscreen) {
      this.video.webkitExitFullscreen()
    } else {
      this.plyr.fullscreen.exit()
    }
    if (this.vnode.context.isStreamingAd) {
      this.toggleControls(false)
      this.plyr.currentTime = this.vnode.context.currentTime
      this.flagShowCmSkip = false
      this.flagShowCmTarget = false
    }
    this.vnode.context.$emit('ended')
  }

  onPause() {
    this.vnode.context.$emit('pause')
  }

  onEnterFullscreen() {
    this.plyrElem.classList.add('plyr--fullscreen--enter')
    this.header.classList.add('header--fullscreen')
    if (isPC) {
      this.theaterBtn.setAttribute('style', 'display:none')
    }
    // if (!screenfull.enabled && this.video.webkitEnterFullscreen) {
    //   this.video.webkitEnterFullscreen()
    //   this.plyr.fullscreen.exit()
    // }
    if (isIos) {
      this.setMainElemStyle('80vh', '80vh', 'hidden')
    }
    this.gaEvent({ event: 'click', category: 'fullscreen-mode', label: 'on' })
  }

  onExitFullscreen() {
    if (isPC) {
      this.theaterBtn.setAttribute('style', 'display:block')
    }
    this.plyrElem.classList.remove('plyr--fullscreen--enter')
    this.header.classList.remove('header--fullscreen')
    if (isIos) {
      this.setMainElemStyle('auto', '100vh', 'static')
      window.scrollTo(0, this.scrollTop)
    }
    this.gaEvent({ event: 'click', category: 'fullscreen-mode', label: 'off' })
  }

  onSeeking() {
    if (!this.vnode.context.isSeeking) {
      this.vnode.context.$emit('seeking')
    }
  }
  onSeeked() {
    this.vnode.context.$emit('seeked')
  }
  setPoster() {
    this.posterElem = document.createElement('img')
    if (isSP) {
      this.posterElem.setAttribute('src', `${this.vnode.context.poster}?s=480`)
    }
    if (isPC) {
      this.posterElem.setAttribute('src', `${this.vnode.context.poster}?s=640`)
      this.posterElem.setAttribute('srcset', `${this.vnode.context.poster}?s=1280 2x`)
    }
    this.posterElem.classList.add('videoControls__poster')
    this.video.parentElement.appendChild(this.posterElem)
    this.video.style.display = 'none'
  }

  setMainElemStyle(height, minHeight, overflow) {
    this.main.style.height = height
    this.main.style.overflow = overflow
    this.main.style.minHeight = minHeight
  }

  toggleControls(isVisible) {
    const className = 'videoControls--disabled'
    if (isVisible) {
      this.plyrControls.classList.remove(className)
    } else {
      this.plyrControls.classList.add(className)
      if (this.vnode.context.isStreamingAd) {
        document.querySelector('.plyr__time.plyr__time--current').textContent = '00:00'
        document.querySelector('.plyr__progress > input[type="range"]').setAttribute('style', '--value: 0%;')
      }
    }
  }
  gaEvent(data) {
    sendGaEvent(
      Object.assign(data, {
        trackingCode: 'UA-100415034-1'
      })
    )
    sendGaEvent(
      Object.assign(data, {
        trackingCode: 'UA-100415034-5'
      })
    )
  }
  // toggleControlsCm(isVisible: boolean): void {
  //   const className = 'videoControls--disabled-cm'
  //   if (isVisible) {
  //     this.plyrControls.classList.remove(className)
  //   } else {
  //     this.plyrControls.classList.add(className)
  //   }
  // }

  setScrollTop() {
    this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
  }
}

let liveVideoControls
let vodVideoControls

Vue.directive('videoControls', {
  inserted(el, binding, vnode) {
    if (binding.arg === 'live') {
      liveVideoControls = new LiveVideoControls(el, binding, vnode)
      liveVideoControls.initialize()
    } else {
      vodVideoControls = new VodVideoControls(el, binding, vnode)
    }
  },
  update(el, binding) {
    if (binding.arg !== 'live' && binding.oldValue !== binding.value) {
      vodVideoControls.toggleControls(binding.value)
    }
  }
})



// WEBPACK FOOTER //
// ./resources/assets/js/directive/videoControls.js